import styled from "styled-components";
import { Colors } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

const IconContainer = styled.div`
  outline: 2px solid var(--zds-background-weaker);
  outline-offset: -1px;

  background-image: linear-gradient(
    140deg,
    hsl(34deg 100% 72%) 0%,
    hsl(29deg 99% 64%) 26%,
    hsl(25deg 100% 57%) 39%,
    hsl(19deg 100% 50%) 50%,
    hsl(342deg 100% 67%) 61%,
    hsl(314deg 85% 75%) 74%,
    hsl(248deg 100% 86%) 100%
  );
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* Applies gradient to icon */
  background-color: var(--zds-prime-white);
  mix-blend-mode: lighten;
`;

const AIBetaWrapper = styled.div<{ $variant?: string }>`
  display: flex;
  align-items: center;
  gap: 2px;
  background-color: ${(props) =>
    props.$variant === "default" ? Colors.UiPrimaryWeakest : "unset"};
  padding: 2px 4px;
  border-radius: var(--zds-radius-xsmall);
  border: ${(props) =>
    props.$variant === "outlined"
      ? `1px solid ${Colors.StrokeDefault}`
      : "none"};
`;

const AIBetaText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.TextDefault};
`;

export function AIBetaDisclaimer({
  variant = "default",
}: {
  variant?: "default" | "outlined";
}) {
  return (
    <AIBetaWrapper $variant={variant}>
      <IconContainer>
        <IconWrapper>
          <Icon name="miscCopilot" color="GrayWarm10" size={16} />
        </IconWrapper>
      </IconContainer>
      <AIBetaText>AI beta</AIBetaText>
    </AIBetaWrapper>
  );
}
